// MODIFIED

import { VESSEL_CONFIG } from '../../../common/selectComponents/VesselPicker';
import { DEPARTMENT_CONFIG } from '../../../common/selectComponents/DepartmentPicker';
import { CLIENT_CONFIG } from '../../../common/selectComponents/ClientPicker';
import { EMPLOYEETYPE_CONFIG } from '../../../common/selectComponents/EmployeeTypePicker';
import { POSITION_CONFIG } from '../../../common/selectComponents/PositionPicker';
import { PAYTYPE_CONFIG } from '../../../common/selectComponents/PaytypeTypePicker';
import { PAYROLLPERIOD_CONFIG } from '../../../common/selectComponents/PayrollPeriodPicker';
import { CLASSIFICATION_CONFIG } from '../../../common/selectComponents/ClassificationPicker';
import { COMPANY_CONFIG } from '../../../common/selectComponents/CompanyPicker';
import { LOCATION_CONFIG } from '../../../common/selectComponents/Location';
import { EMPLOYEE_CONFIG } from '../../../common/selectComponents/EmployeePicker';
import { FEATURES } from '../../../config/features';
import { EFFECTIVE_DATE_MSC_HISTORY_CONFIG } from '../../../common/selectComponents/EffectiveDateMSCHistoryPicker';

export const UI_TYPES = {
  DROPDOWN: 'dropdown',
  PICKER: 'picker',
  DATE: 'date',
  MONTH: 'month',
  YEAR: 'year',
  SELECT_STATIC: 'select_static',
  TEXT: 'text'
};

export const PAYLOAD_TYPES = {
  MAINTENANCE: 'maintenance', // Goes into the [{type, value}] array
  ADDITIONAL: 'additional'    // Goes into the { key: value } object
};

export const FILTER_CONFIG = {
  // -- Maintenance Filters --
  "COMPANY": {
    dropdownTypeKey: "COMPANY", // make sure that this is the same from the DropdownType on the backend
    label: "Company",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: COMPANY_CONFIG
  },
  "LOCATION": {
    dropdownTypeKey: "LOCATION", // make sure that this is the same from the DropdownType on the backend
    label: "Location",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: LOCATION_CONFIG
  },
  "PAYTYPE": {
    dropdownTypeKey: "PAYTYPE", // make sure that this is the same from the DropdownType on the backend
    label: "Paytype",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: PAYTYPE_CONFIG
  },
  "PAYROLLPERIOD": {
    dropdownTypeKey: "PAYROLLPERIOD", // make sure that this is the same from the DropdownType on the backend
    label: "PayrollPeriod",
    uiType: UI_TYPES.PICKER,
    pickerConfig: PAYROLLPERIOD_CONFIG,
    dependsOn: ["PAYTYPE"]
  },
  "CLASSIFICATION": {
    dropdownTypeKey: "PAYROLLPERIOD", // make sure that this is the same from the DropdownType on the backend
    label: "Classification",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: CLASSIFICATION_CONFIG
  },
  "DEPARTMENT": {
    dropdownTypeKey: "DEPARTMENT", // make sure that this is the same from the DropdownType on the backend
    label: "Department",
    uiType: FEATURES.DEPARTMENT_FILTER_UI_TYPE === "picker" ? UI_TYPES.PICKER : UI_TYPES.DROPDOWN,
    pickerConfig: DEPARTMENT_CONFIG
  },
  "VESSEL": {
    dropdownTypeKey: "VESSEL", // make sure that this is the same from the DropdownType on the backend
    label: "Vessel",
    uiType: UI_TYPES.PICKER,
    pickerConfig: VESSEL_CONFIG
  },
  "CLIENT": {
    dropdownTypeKey: "CLIENT", // make sure that this is the same from the DropdownType on the backend
    label: "Client",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: CLIENT_CONFIG
  },
  "EMPLOYEE_TYPE": {
    dropdownTypeKey: "EMPLOYEE_TYPE", // make sure that this is the same from the DropdownType on the backend
    label: "Employee Type",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: EMPLOYEETYPE_CONFIG
  },
  "POSITION": {
    dropdownTypeKey: "POSITION", // make sure that this is the same from the DropdownType on the backend
    label: "Position",
    uiType: UI_TYPES.PICKER,
    pickerConfig: POSITION_CONFIG,
    dependsOn: ["DEPARTMENT"]
  },

  // --- Customize Dynamic Salary Toggler ---
  "DEPARTMENT_MSC_TOGGLE": {
    dropdownTypeKey: "DEPARTMENT", // make sure that this is the same from the DropdownType on the backend
    label: "Department",
    uiType: FEATURES.DEPARTMENT_FILTER_UI_TYPE === "picker" ? UI_TYPES.PICKER : UI_TYPES.DROPDOWN,
    pickerConfig: DEPARTMENT_CONFIG,
    dependsOn: ["EMPLOYEE_TYPE"],
    // NEW: Map the state key to the API query param name
    dependencyMap: {
      "EMPLOYEE_TYPE": "employeeTypeId"
    },
    isVisible: (state) => {
      const empType = state["EMPLOYEE_TYPE"];
      // 1. If no employee type is selected, show the filter
      if (!empType) return true;

      // 2. Return TRUE only if we should NOT disregard other filters
      // This explicitly returns true for Off-Shore (false !== true)
      return empType?.maintenanceSalaryCombinationDisregardOtherFilter !== true;
    }
  },

  "POSITION_MSC_TOGGLE": {
    dropdownTypeKey: "POSITION", // make sure that this is the same from the DropdownType on the backend
    label: "Position",
    uiType: UI_TYPES.PICKER,
    pickerConfig: POSITION_CONFIG,
    dependsOn: ["DEPARTMENT_MSC_TOGGLE"],
    // NEW: Map the state key to the API query param name
    dependencyMap: {
      "DEPARTMENT_MSC_TOGGLE": "departmentId"
    },
    isVisible: (state) => {
      const empType = state["EMPLOYEE_TYPE"];
      if (!empType) return true;

      // Same logic here
      return empType?.maintenanceSalaryCombinationDisregardOtherFilter !== true;
    }
  },

  // -- Additional Filters --
  "EFFECTIVE_DATE": {
    label: "Effective Date",
    uiType: UI_TYPES.DATE,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "effectiveDate", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  "EFFECTIVE_DATE_MSC_HISTORY_DROPDOWN": {
    label: "Effective Date",
    uiType: UI_TYPES.DROPDOWN,
    pickerConfig: EFFECTIVE_DATE_MSC_HISTORY_CONFIG,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "effectiveDate", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  "DATE_FROM": {
    label: "Date From",
    uiType: UI_TYPES.DATE,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "dateFrom", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  "DATE_TO": {
    label: "Date To",
    uiType: UI_TYPES.DATE,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "dateTo", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  "MONTH": {
    label: "Month",
    uiType: UI_TYPES.MONTH,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "month", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  "YEAR": {
    label: "Year",
    uiType: UI_TYPES.YEAR,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "year", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  "EMPLOYEE": {
    label: "Employee",
    uiType: UI_TYPES.PICKER,
    pickerConfig: EMPLOYEE_CONFIG,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "employeePersonalInformationId", // The key name used in additionalApiFilterPayload
    isRequired: false
  },

  // ADDED: Example of a Static Dropdown (Non-DB)
  "STATUS": {
    label: "Status",
    uiType: UI_TYPES.SELECT_STATIC,
    payloadType: PAYLOAD_TYPES.ADDITIONAL,
    payloadKey: "status",
    options: [
      { value: 'active', name: 'Active' },
      { value: 'inactive', name: 'Inactive' }
    ]
  },
};

/// deprecated
export const SALARY_FILTER_MAP = {
  "COMPANY": "companyId", // if applicable
  "DEPARTMENT": "departmentId",
  "POSITION": "positionId",
  "EMPLOYEE_TYPE": "employeeTypeId",
  "VESSEL": "vesselId",
  "CLASSIFICATION": "classificationId",
  "PAY_TYPE": "payTypeId",
  "LOCATION": "locationId",
  "CLIENT": "clientId"
};

export const TRANSACTION_SALARY_FILTER_MAP = {
  "DEPARTMENT": "departmentId",
  "POSITION": "tempPositionId",      // Transaction uses 'temp'
  "EMPLOYEE_TYPE": "tempEmployeeTypeId",
  "VESSEL": "tempVesselId",
  "CLASSIFICATION": "classificationId",
  "PAY_TYPE": "payTypeId"            // From Compensation Tab
};